import React from 'react';

import { Box } from '@material-ui/core';

import { AppButton, OnboardingStepTitle } from '../../../../components';

interface Props {
  /** True once the wizard has moved past this step — the choice is made, the buttons only show it. */
  answered: boolean;
  /** True when this step's answer was "add another shift". */
  addedAnother: boolean;
  onAddAnother: () => void;
  onSkip: () => void;
}

const styles = { width: 180, marginRight: 8 };

export const AddAnotherShiftStep: React.FC<Props> = ({ answered, addedAnother, onAddAnother, onSkip }) => {
  return (
    <>
      <OnboardingStepTitle
        text="Add another shift to this location?"
        additionalText="Locations can run as many shifts as you need — days, nights, weekends. You can always add more later from the location’s settings."
      />

      <Box display="flex" justifyContent="center" flexWrap="wrap" gridGap={8} marginTop={2}>
        <AppButton
          onClick={onAddAnother}
          disabled={answered}
          size="large"
          style={styles}
          variant={answered && addedAnother ? 'contained' : 'outlined'}
          color="primary"
        >
          Add another shift
        </AppButton>

        <AppButton
          onClick={onSkip}
          disabled={answered}
          size="large"
          style={styles}
          variant={answered && !addedAnother ? 'contained' : 'outlined'}
          color="primary"
        >
          Not right now
        </AppButton>
      </Box>
    </>
  );
};
